import { h } from '@stencil/core';
import { getDataAttributes, getQdsIconLibrary } from '@pes-ui/utils';
export class AddToCartButton {
  constructor() {
    this.isInList = false;
    this.labels = {};
    this.button = undefined;
    this.size = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderIcon() {
    var _a;
    if ((_a = this.button) === null || _a === void 0 ? void 0 : _a.icons) {
      const { icons } = this.button;
      return icons.addIcon;
    }
    return "shopping-cart";
  }
  render() {
    var _a, _b, _c, _d, _e;
    const icon = this.renderIcon();
    let buttonProps = {
      'data-da-element-id': 'add_p',
      'data-autotests-id': 'uiaas-product-card-cta-add-to-cart',
    };
    if ((_a = this.button) === null || _a === void 0 ? void 0 : _a.isShown) {
      const { dataset = {} } = this.button;
      const dataProps = getDataAttributes(dataset);
      buttonProps = Object.assign(Object.assign({}, buttonProps), dataProps);
    }
    const label = this.isInList
      ? ((_c = (_b = this.button) === null || _b === void 0 ? void 0 : _b.labels) === null || _c === void 0 ? void 0 : _c.removeLabel) || this.labels.removeFromCartLabel
      : ((_e = (_d = this.button) === null || _d === void 0 ? void 0 : _d.labels) === null || _e === void 0 ? void 0 : _e.addLabel) || this.labels.addToCartLabel;
    return (h("qds-button", Object.assign({ class: "add-to-cart-button" }, buttonProps, { size: this.size, variant: "hero", importance: "standard", text: label, iconName: icon, iconLibrary: getQdsIconLibrary(icon) })));
  }
  static get is() { return "add-to-cart-button"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["add-to-cart-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["add-to-cart-button.css"]
    };
  }
  static get properties() {
    return {
      "isInList": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If product is already added into list"
        },
        "attribute": "is-in-list",
        "reflect": false,
        "defaultValue": "false"
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Partial<ProductsApi.Labels>",
          "resolved": "{ partnerPriceLabel?: string; compareLabel?: string; addToMyProductsLabel?: string; removeFromMyProductsLabel?: string; addToCartLabel?: string; removeFromCartLabel?: string; buyOnlineLabel?: string; viewDetailsLabel?: string; shippingLabel?: string; deliveryDeadlineLabel?: string; gridViewLabel?: string; listViewLabel?: string; addedToMyProductsLabel?: string; removedFromMyProductsLabel?: string; viewMyProductsLabel?: string; addedToCartLabel?: string; removedFromCartLabel?: string; viewCartLabel?: string; bundleDetails?: string; bundleItems?: string; bundlePrice?: string; bundleAddButton?: string; bundlePriceAll?: string; bundleAddAllButton?: string; purchaseOnAPCLabel?: string; buyMarketplaceLabel?: string; }",
          "references": {
            "Partial": {
              "location": "global"
            },
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Button labels"
        },
        "defaultValue": "{}"
      },
      "button": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TCTAButtonSettings",
          "resolved": "TBaseCTAButtonSettings & { labels?: { addLabel?: string; removeLabel?: string; }; icons?: { addIcon?: string; removeIcon?: string; disableIconInPdpCtaBlock?: boolean; }; }",
          "references": {
            "TCTAButtonSettings": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Button settings."
        }
      },
      "size": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TAddToCardButtonSize",
          "resolved": "EQdsButtonSize.LARGE | EQdsButtonSize.STANDARD",
          "references": {
            "TAddToCardButtonSize": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Button size."
        },
        "attribute": "size",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
